import { useCallback, useEffect, useState } from "react";
import { endTimer, selectActiveTimer, selectHuntTimer, startTimer } from "../redux/EvidenceSlice";
import { useAppDispatch, useAppSelector } from "../redux/Hooks";
import { StopWatch, calculateTimeInSeconds, formatStopWatch } from "../types/StopWatch";

export default function HuntTimer() {
    const dispatch = useAppDispatch();
    const timer = useAppSelector(selectHuntTimer);
    const active = useAppSelector(selectActiveTimer) === 'hunt timer';
    const [counter, setCounter] = useState(0);

    const handleKey: EventListener = useCallback((event) => {
        if ('key' in event) {
            const key = `${event.key}`.toLowerCase();

            if (key === 'h') {
                if (timer === null || !!timer.end) {
                    dispatch(startTimer('hunt timer'));
                } else {
                    dispatch(endTimer('hunt timer'));
                }
            }
        }
    }, [dispatch, timer]);

    useEffect(() => {
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [handleKey]);

    useEffect(() => {
        const timer = setTimeout(() => setCounter(counter + 1), 1000);
        return () => clearTimeout(timer);
    }, [counter]);

    return (
        <div className="text-end">
            <FormattedTimer timer={timer} active={active} />
            <HuntHint timer={timer} />
        </div>
    );
}

function FormattedTimer({ timer, active }: { timer: StopWatch | null, active: boolean }) {
    if (timer) {
        const formattedTimer = formatStopWatch(timer, false);
        const formattedAdjustedTimer = formatStopWatch(timer, true);
        const offset = timer.offset ?? 0;

        return (
            <div className="fw-lighter">
                {active && <i className="bi-chevron-right"></i> }
                <small className="me-2 text-muted fs-6">Hunt</small>
                {offset !== 0 && <span>{formattedTimer}</span>}
                {offset !== 0 && <span className="text-warning ms-1 me-1">{offset > 0 ? `+${offset} s ` : `${offset} s `}</span>}
                {offset !== 0 && <span className="me-2">=</span>}
                <span>{formattedAdjustedTimer}</span>
            </div>
        );
    }

    return null;
}

function HuntHint({ timer }: { timer: StopWatch | null }) {
    if (!!timer) {
        const seconds = calculateTimeInSeconds(timer);
        if (seconds <= 25) {
            if (!!timer.end) {
                return <div className="text-danger fw-lighter"><small>Demon</small></div>;
            } else {
                return <div className="text-warning fw-lighter"><small>possible Demon</small></div>;
            }
        }
    }

    return null;
}